import React from 'react';
import {Atom, Plugins, withSystem} from '@packages/systems/wfdl';
import {excludeSearchByDefaultType} from '@packages/systems/search';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TText, TListOfElement, TRecord} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const Icon = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const iconClasses = classes.push(`w-icon-${data.widget.icon}`);
    return (
      <div {...generateAttributes(attributes, iconClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  render: Icon,
  fields: {
    search: withSystem(
      {private: true},
      TRecord({
        exclude: excludeSearchByDefaultType,
      })
    ),
    children: withSystem({private: true}, TListOfElement),
    widget: withSystem(
      {private: true},
      TRecord({
        type: TText,
        icon: TText,
      })
    ),
  },
});

export default config;
